import React, { useEffect, useState, useRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { withRouter } from 'react-router-dom';
import monster from '../../images/market/monster.svg';
import feed from '../../images/market/feed.svg';
import cauldrons from '../../images/market/cauldrons.svg';
import coinsBox from '../../images/market/coin-box.svg';
import plots from '../../images/market/plots.svg';
import potion from '../../images/market/potions.svg';
import cave from '../../images/market/caves.svg';
import laboratory from '../../images/market/laboratory.svg';

const SideBox = ({history, match, location}) => {
    const [detailObj, setDetailObj] = useState({});
    const [active, setActive] = useState('');
    const categoryArray = [
    {image:plots ,name: 'plot',detail: 'There are 4 different Islands and every Island has dozens of Plots. Offering Plots of different sizes, prices, features, and facilities for players to have an Island plot of their choice to grow their game career. Either one owns a plot or takes a plot on rent, having an island plot is required for every player who wants to start a Monsters Clan game career. Players can buy, sell, and rent island plots through Monsters Clan NFT marketplace. ' },
    {image: cave ,name: 'cave', detail : 'Monsters need their special place to rest and relax so here presenting a Monster Cave. Every monster cave will have a capacity to keep a fixed number of monsters. There are different levels of Monster caves available having different capacities for Monsters. One must have at least one Monster Cave on his plot if he owns Monsters. Players can buy, sell, and rent Monster Caves in through Monsters Clan NFT marketplace.'},
    {image: monster,name: 'monster', detail: 'Monsters are the ultimate characters one has to own in order to play a Monsters Clan game and participate in fights. There are hundreds of Monsters having different rarity levels, types, price, and attributes. Players can buy and sell Monsters through the Monsters Clan NFT marketplace. '},
    {image: laboratory, plural: 'laboratories',name: 'laboratory', detail: 'Monster Laboratory is a special laboratory set up for performing all chemical processes related to Monsters under Professor Monsalito, the incharge of laboratories in Monsters Clan.Players can create monster babies from potions and also create special feeds in a laboratory. One can buy, sell, or rent laboratories through Monsters Clan NFT Marketplace.' },
    {image: cauldrons,name: 'cauldron', detail: 'A big pot required for generating a monster potion with the help of two monsters. There are different types of Potion cauldrons available on the marketplace. One can buy, sell, or rent a potion cauldron through Monsters Clan NFT Marketplace.' },
    {image: coinsBox,plural: 'Coin boxes' ,name: 'coin box', detail :'Coins Storage Box is to store in-game coins , there are different levels of coin storage boxes available having different capacity to store coins. One can buy or sell coin storage boxes through Monsters Clan NFT Marketplace. ' },
    {image: potion,name: 'potion', detail: 'Monster Potion is a core chemical product that will be used to create a new baby monster. Player will have to start generating a Monster Potion in the potion cauldron putting his two potioner monsters on duty. Afterwards, Monster potion can be processed in the specific laboratory to create a baby monster. Players can buy or sell potions through Monsters Clan NFT Marketplace. ' },
    {image: feed,name: 'feed', detail :'Introducing special feeds for players to feed and upgrade their Monsters. There are different types of monster feeds that players can buy from Monsters Clan NFT Marketplace. ' },
  ];
    const preloadedSpinner = useRef();

  useEffect(()=>{
    categoryArray.forEach((cat) => {
      preloadedSpinner.current = new Image();
      preloadedSpinner.current.src = cat.image
    });
    if(location.pathname.includes('assets')) {
      const name = history.location.pathname.slice(21);
      setActive(name);
      const obj = categoryArray.find(cat => cat.name === name);
      setDetailObj(obj)
    }
    else if (location.pathname.includes('asset')) {
      const name = history.location.pathname.slice(20, -25);
      setActive(name);
      const obj = categoryArray.find(cat => cat.name === name);
      setDetailObj(obj)
    }
    else {
      const name = history.location.pathname.slice(19);
      setActive(name);
      console.log(name)
      const obj = categoryArray.find(cat => cat.name === name);
      setDetailObj(obj)
    }
    console.log(history.location)
    },[])

  const setCategoryName = (name) => {
    console.log(name)
      setActive(name)
      setDetailObj(categoryArray.find(cat => cat.name === name && cat));
      history.push({pathname: `/market-place/assets/${name}`})
  }
  return (
    
    <div className="col-lg-4 col-sm-12">
      <div className="first-box">
        <h5 className="heading">MONSTERSCLAN INVENTORY</h5>
        <Scrollbars style={ { height: 300, width: 'auto' } }
          className="scroll"
          renderTrackHorizontal={ props => <div { ...props } className="track-horizontal"/> }
          renderTrackVertical={ props => <div { ...props } className="track-vertical"/> }>
            <div className="row no-gutters">
              {categoryArray.map(inventry => (
                <div className="col-4">
                  <div onClick={()=> setCategoryName(inventry.name)} className={`${active === inventry.name ? 'active': '' } sub-box`}>
                    <img src={inventry.image} alt=""/>
                    {(inventry.name !== 'laboratory' && inventry.name !== 'coin box') &&<p>{inventry.name.toLocaleUpperCase()}S</p>}
                    {(inventry.name === 'laboratory' || inventry.name === 'coin box') &&<p>{inventry.plural.toLocaleUpperCase()}</p>}
                  </div>
                </div>
              ))}
            </div>
        </Scrollbars>
      </div>
      <div className="sec-box">
        <img src={detailObj && detailObj.image} alt=""/>
        <div>
          <h5>{detailObj && detailObj.name}</h5>
          <p>{detailObj && detailObj.detail}</p>
          </div>
      </div>
    </div>
    
  )
}

export default withRouter(SideBox);